import { NgModule } from '@angular/core';
import { AuthModule } from 'marida';
import { BASE_PATH } from './api/variables';
import { environment } from '../environments/environment';

@NgModule({
    imports  : [AuthModule],
    providers: [{ provide: BASE_PATH, useValue: environment.apiUrl }],
    exports: []
})
export class MaridaModule {

}
